<template>
    <b-nav class="w-100 provider_menu cabinet_menu mb-3" vertical>
        <cabinet-submenu path="/cabinet/fl44" title="44-ФЗ" strong :attention="attentionForSections(['CabinetFl44NoticesList', 'CabinetFl44ContractsList', 'CabinetFl44ProposalsList', 'CabinetFl44PurchaseReports'])">
            <cabinet-submenu-item v-if="orgRoleIsPermitted($orgRoles.CUSTOMER_FL44)" :to="{ name: 'CabinetFl44NoticesList' }" :attention="attentionFor('CabinetFl44NoticesList')">Извещения</cabinet-submenu-item>
            <cabinet-submenu-item :to="{ name: 'CabinetFl44ContractsList' }" :attention="attentionFor('CabinetFl44ContractsList')">Контракты</cabinet-submenu-item>
            <cabinet-submenu-item :to="{ name: 'CabinetFl44ProposalsList' }" :attention="attentionFor('CabinetFl44ProposalsList')"> Предложения </cabinet-submenu-item>
            <cabinet-submenu-item v-if="orgRoleIsPermitted($orgRoles.CUSTOMER_FL44)" :to="{ name: 'CabinetFl44PurchaseReports' }" :attention="attentionFor('CabinetFl44PurchaseReports')">Отчеты по закупкам</cabinet-submenu-item>
            <cabinet-submenu-item v-if="orgRoleIsPermitted($orgRoles.CUSTOMER_FL44)" :to="{ name: 'CabinetFl44BlockRequests' }">Запросы блокировок</cabinet-submenu-item>
            <cabinet-submenu-item v-if="orgRoleIsPermitted($orgRoles.CUSTOMER_FL44)" :to="{ name: 'CabinetFl44LimitsList' }">Лимиты БО</cabinet-submenu-item>
            <cabinet-submenu-item :to="{ name: 'CabinetFl44RatingHistory' }">История рейтинга</cabinet-submenu-item>
        </cabinet-submenu>

        <cabinet-submenu path="/cabinet/fl223" title="223-ФЗ" strong :attention="attentionForSections(['CabinetFl223Notices', 'CabinetFl223Contracts', 'CabinetFl223ProposalsList'])">
            <cabinet-submenu-item v-if="orgRoleIsPermitted($orgRoles.CUSTOMER_FL223)" :to="{ name: 'CabinetFl223Notices' }" :attention="attentionFor('CabinetFl223Notices')">Извещения</cabinet-submenu-item>
            <cabinet-submenu-item :to="{ name: 'CabinetFl223Contracts' }" :attention="attentionFor('CabinetFl223Contracts')">Договоры</cabinet-submenu-item>
            <cabinet-submenu-item :to="{ name: 'CabinetFl223ProposalsList' }" :attention="attentionFor('CabinetFl223ProposalsList')">Предложения</cabinet-submenu-item>
            <cabinet-submenu-item v-if="orgRoleIsPermitted($orgRoles.CUSTOMER_FL223)" :to="{ name: 'CabinetFl223Settings' }">Настройки</cabinet-submenu-item>
        </cabinet-submenu>

        <cabinet-submenu path="/cabinet/commercial" title="Коммерческие" strong :attention="attentionForSections(['CabinetCommercialNotices', 'CabinetCommercialContracts', 'CabinetCommercialProposalsList'])">
            <cabinet-submenu-item v-if="orgRoleIsPermitted($orgRoles.CUSTOMER_COMMERCIAL)" :to="{ name: 'CabinetCommercialNotices' }" :attention="attentionFor('CabinetCommercialNotices')"> Извещения </cabinet-submenu-item>
            <cabinet-submenu-item :to="{ name: 'CabinetCommercialContracts' }" :attention="attentionFor('CabinetCommercialContracts')">Договоры</cabinet-submenu-item>
            <cabinet-submenu-item :to="{ name: 'CabinetCommercialProposalsList' }" :attention="attentionFor('CabinetCommercialProposalsList')"> Предложения </cabinet-submenu-item>
        </cabinet-submenu>

        <cabinet-submenu path="/cabinet/quotation_requests" title="Запросы КП">
            <cabinet-submenu-item :to="{ name: 'CabinetQuotationRequestsList', params: { cat: 'all' } }">Запросы</cabinet-submenu-item>
            <cabinet-submenu-item :to="{ name: 'CabinetQuotationRequestsOffersList', params: { cat: 'all' } }">Предложения</cabinet-submenu-item>
        </cabinet-submenu>

        <cabinet-menu-item :to="{ name: 'CabinetAccounting' }">Лицевой счет</cabinet-menu-item>

        <cabinet-submenu path="/cabinet/ktru" title="КТРУ">
            <cabinet-submenu-item :to="{ name: 'CabinetKtruRequestsList' }">Запросы на добавление позиции</cabinet-submenu-item>
            <cabinet-submenu-item :to="{ name: 'CabinetKtruFavoritesList' }">Избранное</cabinet-submenu-item>
            <!--            <cabinet-submenu-item :to="{ name: 'KtruFavoritesList' }">Избранное<span class="atmo-badge" style="left: 94px; top: 5px">Новое</span></cabinet-submenu-item>-->
        </cabinet-submenu>
        <cabinet-menu-item :to="{ name: 'CabinetNotificationsList' }">Уведомления</cabinet-menu-item>
        <cabinet-menu-item :to="{ name: 'CabinetPersonalAddresses' }">Адресная книга</cabinet-menu-item>

        <cabinet-menu-item :to="{ name: 'CabinetOrganizationReliabilityReport' }">Проверка контрагентов</cabinet-menu-item>

        <cabinet-submenu :path="['/cabinet/organization', '/cabinet/user_profile']" title="Об организации">
            <cabinet-submenu-item :to="{ name: 'CabinetOrganizationProfile' }">Информация об организации</cabinet-submenu-item>
            <cabinet-submenu-item :to="{ name: 'CabinetUserProfile' }">Данные учетной записи</cabinet-submenu-item>
            <cabinet-submenu-item :to="{ name: 'CabinetUsersList' }">Пользователи организации</cabinet-submenu-item>
        </cabinet-submenu>
    </b-nav>
</template>

<script>
import CabinetMenuItem from '@/components/cabinet/CabinetMenuItem.vue';
import CabinetSubmenu from '@/components/cabinet/CabinetSubmenu.vue';
import CabinetSubmenuItem from '@/components/cabinet/CabinetSubmenuItem.vue';

export default {
    name: 'cabinet-sidenav',
    components: { CabinetSubmenuItem, CabinetSubmenu, CabinetMenuItem },
    methods: {
        isActive(path) {
            return this.$route.name === path;
        },
        attentionFor(section) {
            return this.$store.state.actionSummary[section] ?? null;
        },
        attentionForSections(sections) {
            const summary = sections.map((section) => this.attentionFor(section)).filter(Boolean);
            if (!summary.length) {
                return null;
            }

            return summary.reduce(
                (result, section) => ({
                    total: result.total + section.total,
                    actions: { ...result.actions, ...section.actions }
                }),
                { total: 0, actions: {} }
            );
        }
    }
};
</script>
<style scoped>
.cabinet_menu {
    position: -webkit-sticky;
    position: sticky;
    top: 160px;
    -webkit-box-shadow: 0 0 10px -5px #aaa;
    -moz-box-shadow: 0 0 10px -5px #aaa;
    box-shadow: 0 0 10px -5px #aaa;
}

.cabinet_menu li {
    position: relative;
    background: #fff;
}

.cabinet_menu li a {
    border-left: 8px solid transparent;
    font-size: 14px;
    padding: 10px;
    color: var(--grey-color);
}

.cabinet_menu li + li {
    border-top: 1px solid rgba(149, 155, 164, 0.25);
}

.provider_menu .cabinet_submenu li {
    border-top: none !important;
}

.provider_menu .cabinet_submenu li a {
    font-size: 14px;
    color: var(--grey-color);
}

.provider_menu .cabinet_submenu li a:active {
    background: transparent;
}

.provider_menu .cabinet_submenu li a:hover {
    background: transparent;
}
</style>
